import { render, staticRenderFns } from "./zCentralizedToolbar.vue?vue&type=template&id=673f26e0&scoped=true&"
import script from "./zCentralizedToolbar.vue?vue&type=script&lang=js&"
export * from "./zCentralizedToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673f26e0",
  null
  
)

export default component.exports